import { gql } from '@apollo/client';

export const HideWelcomeMessage = gql`
mutation HideWelcomeMessage($hideWelcomeMessageId: ID!) {
  hideWelcomeMessage(id: $hideWelcomeMessageId) {
    status
  }
}
`;